// import React, { useEffect, useState, useRef } from "react";
// import {
//   Box,
//   Fade,
//   styled,
//   Typography,
//   Grow,
//   Grid,
//   Container,
//   Button,
//   alpha,
//   useTheme,
// } from "@mui/material";
// import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
// import s1image from "assets/s1image.jpg";
// import LoginForm from "components/LoginForm";
// import { useLocation, useNavigate } from "react-router-dom";
// import CaregiverApplyForm from "pages/Caregiver/CaregiverApplyForm";
// import ClientInterestForm from "components/ClientInterestForm";
// import CheckCircleIcon from "@mui/icons-material/CheckCircle";
// import LocalHospitalIcon from "@mui/icons-material/LocalHospital";
// import PeopleIcon from "@mui/icons-material/People";
// import AccessTimeIcon from "@mui/icons-material/AccessTime";

// const HeroSection = styled(Box)(({ theme }) => ({
//   minHeight: "100vh",
//   display: "flex",
//   alignItems: "center",
//   position: "relative",
//   overflow: "hidden",
//   background: "linear-gradient(135deg, #f8f9fa 0%, #e8f5e9 100%)",
//   paddingTop: theme.spacing(12),
//   paddingBottom: theme.spacing(8),
//   [theme.breakpoints.down("md")]: {
//     paddingTop: theme.spacing(8),
//   },
// }));

// const HeroImage = styled("img")(({ theme }) => ({
//   width: "100%",
//   height: "100%",
//   objectFit: "cover",
//   borderRadius: theme.shape.borderRadius * 3,
//   boxShadow: theme.shadows[12],
//   transform: "perspective(1000px) rotateY(-5deg)",
//   transition: "all 0.5s ease",
//   "&:hover": {
//     transform: "perspective(1000px) rotateY(0deg)",
//   },
//   [theme.breakpoints.down("md")]: {
//     transform: "none",
//     marginBottom: theme.spacing(4),
//   },
// }));

// const Title = styled(Typography)(({ theme }) => ({
//   fontSize: "3.5rem",
//   fontWeight: 800,
//   lineHeight: 1.1,
//   background: "linear-gradient(135deg, #2c3e50 0%, #667eea 100%)",
//   WebkitBackgroundClip: "text",
//   WebkitTextFillColor: "transparent",
//   fontFamily: "'Poppins', sans-serif",
//   marginBottom: theme.spacing(3),
//   [theme.breakpoints.down("lg")]: {
//     fontSize: "3rem",
//   },
//   [theme.breakpoints.down("md")]: {
//     fontSize: "2.5rem",
//   },
//   [theme.breakpoints.down("sm")]: {
//     fontSize: "2rem",
//   },
// }));

// const HighlightedText = styled("span")({
//   background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
//   WebkitBackgroundClip: "text",
//   WebkitTextFillColor: "transparent",
// });

// const PrimaryButton = styled(Button)(({ theme }) => ({
//   background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
//   color: "white",
//   padding: theme.spacing(1.5, 4),
//   borderRadius: theme.shape.borderRadius * 2,
//   fontSize: "1rem",
//   fontWeight: 600,
//   textTransform: "none",
//   transition: "all 0.3s ease",
//   boxShadow: theme.shadows[3],
//   "&:hover": {
//     transform: "translateY(-3px)",
//     boxShadow: theme.shadows[6],
//   },
// }));

// const FeatureItem = styled(Box)(({ theme }) => ({
//   display: "flex",
//   alignItems: "center",
//   gap: theme.spacing(1.5),
//   marginBottom: theme.spacing(2),
//   "& svg": {
//     color: theme.palette.success.main,
//     fontSize: "1.5rem",
//     flexShrink: 0,
//   },
// }));

// const CenteredForm = styled(Box)(({ theme }) => ({
//   position: "fixed",
//   top: "50%",
//   left: "50%",
//   transform: "translate(-50%, -50%)",
//   zIndex: 9999,
//   width: "90%",
//   maxWidth: "500px",
//   backgroundColor: "white",
//   borderRadius: theme.shape.borderRadius * 3,
//   padding: theme.spacing(4),
//   boxShadow: theme.shadows[24],
//   animation: "formAppear 0.5s ease-out",
//   "@keyframes formAppear": {
//     "0%": { opacity: 0, transform: "translate(-50%, -60%) scale(0.9)" },
//     "100%": { opacity: 1, transform: "translate(-50%, -50%) scale(1)" },
//   },
// }));

// const SectionOne = () => {
//   const location = useLocation();
//   const navigate = useNavigate();
//   const theme = useTheme();
//   const [isVisible, setIsVisible] = useState(false);
//   const [showLoginForm, setShowLoginForm] = useState(false);
//   const [showApplyForm, setShowApplyForm] = useState(false);
//   const [showClientForm, setShowClientForm] = useState(false);
//   const sectionRef = useRef();

//   const book = () => {
//     navigate("/clients/new");
//   };

//   useEffect(() => {
//     setShowClientForm(location.pathname === "/clients/new");
//     setShowLoginForm(location.pathname === "/login");
//     setShowApplyForm(location.pathname === "/caregiver/new");
//   }, [location]);

//   useEffect(() => {
//     const observer = new IntersectionObserver(
//       ([entry]) => {
//         if (entry.isIntersecting) {
//           setIsVisible(true);
//         }
//       },
//       { threshold: 0.1 }
//     );

//     if (sectionRef.current) {
//       observer.observe(sectionRef.current);
//     }

//     return () => observer.disconnect();
//   }, []);

//   return (
//     <>
//       {/* Forms overlay */}
//       {showLoginForm && (
//         <Grow in={showLoginForm} timeout={500}>
//           <CenteredForm>
//             <LoginForm />
//           </CenteredForm>
//         </Grow>
//       )}

//       {showApplyForm && (
//         <Grow in={showApplyForm} timeout={500}>
//           <CenteredForm>
//             <CaregiverApplyForm />
//           </CenteredForm>
//         </Grow>
//       )}

//       {showClientForm && (
//         <Grow in={showClientForm} timeout={500}>
//           <CenteredForm>
//             <ClientInterestForm />
//           </CenteredForm>
//         </Grow>
//       )}

//       <HeroSection ref={sectionRef}>
//         {/* Background Elements */}
//         <Box
//           sx={{
//             position: "absolute",
//             top: 0,
//             right: 0,
//             width: "300px",
//             height: "300px",
//             background: `radial-gradient(circle, ${alpha(
//               theme.palette.primary.light,
//               0.3
//             )} 0%, transparent 70%)`,
//             zIndex: 0,
//           }}
//         />
//         <Box
//           sx={{
//             position: "absolute",
//             bottom: 0,
//             left: 0,
//             width: "200px",
//             height: "200px",
//             background: `radial-gradient(circle, ${alpha(
//               theme.palette.secondary.light,
//               0.2
//             )} 0%, transparent 70%)`,
//             zIndex: 0,
//           }}
//         />

//         <Container maxWidth="lg">
//           <Grid container spacing={6} alignItems="center">
//             {/* Left Column - Text Content */}
//             <Grid item xs={12} md={6}>
//               <Fade in={isVisible} timeout={1000}>
//                 <Box sx={{ pr: { md: 4 } }}>
//                   {/* Badge */}
//                   <Box
//                     sx={{
//                       display: "inline-flex",
//                       alignItems: "center",
//                       gap: 1,
//                       backgroundColor: alpha(theme.palette.primary.main, 0.1),
//                       color: theme.palette.primary.main,
//                       padding: theme.spacing(0.75, 2),
//                       borderRadius: theme.shape.borderRadius * 5,
//                       fontWeight: 600,
//                       fontSize: "0.9rem",
//                       marginBottom: theme.spacing(3),
//                     }}
//                   >
//                     <CheckCircleIcon fontSize="small" />
//                     Trusted Home Care Services
//                   </Box>

//                   <Title variant="h1">
//                     Comfort, Compassion & Care -{" "}
//                     <HighlightedText>Right at Home!</HighlightedText>
//                   </Title>

//                   <Typography
//                     variant="h6"
//                     sx={{
//                       color: "text.secondary",
//                       mb: 4,
//                       fontWeight: 400,
//                       lineHeight: 1.6,
//                       fontSize: "1.1rem",
//                     }}
//                   >
//                     We provide professional, compassionate caregivers who
//                     deliver personalized care and support for your loved ones in
//                     the comfort of their own home.
//                   </Typography>

//                   {/* Features */}
//                   <Box sx={{ mb: 5 }}>
//                     <FeatureItem>
//                       <LocalHospitalIcon />
//                       <Box>
//                         <Typography variant="subtitle1" fontWeight={600}>
//                           24/7 Professional Care
//                         </Typography>
//                         <Typography variant="body2" color="text.secondary">
//                           Round-the-clock care from trained professionals
//                         </Typography>
//                       </Box>
//                     </FeatureItem>

//                     <FeatureItem>
//                       <PeopleIcon />
//                       <Box>
//                         <Typography variant="subtitle1" fontWeight={600}>
//                           Compassionate & Trained Staff
//                         </Typography>
//                         <Typography variant="body2" color="text.secondary">
//                           Certified caregivers with empathy and expertise
//                         </Typography>
//                       </Box>
//                     </FeatureItem>

//                     <FeatureItem>
//                       <AccessTimeIcon />
//                       <Box>
//                         <Typography variant="subtitle1" fontWeight={600}>
//                           Personalized Care Plans
//                         </Typography>
//                         <Typography variant="body2" color="text.secondary">
//                           Customized care tailored to individual needs
//                         </Typography>
//                       </Box>
//                     </FeatureItem>
//                   </Box>

//                   {/* CTA Buttons */}
//                   <Box
//                     sx={{ display: "flex", gap: 3, flexWrap: "wrap", mb: 6 }}
//                   >
//                     <PrimaryButton
//                       onClick={book}
//                       endIcon={<ArrowForwardIcon />}
//                       size="large"
//                     >
//                       Book an Appointment
//                     </PrimaryButton>

//                     <Button
//                       variant="outlined"
//                       color="primary"
//                       size="large"
//                       sx={{
//                         borderRadius: theme.shape.borderRadius * 2,
//                         textTransform: "none",
//                         fontWeight: 600,
//                         px: 4,
//                       }}
//                     >
//                       Learn More
//                     </Button>
//                   </Box>

//                   {/* Stats */}
//                   <Grid container spacing={3}>
//                     {[
//                       { number: "500+", label: "Happy Clients" },
//                       { number: "98%", label: "Satisfaction Rate" },
//                       { number: "24/7", label: "Care Available" },
//                     ].map((stat, index) => (
//                       <Grid item xs={4} key={index}>
//                         <Grow in={isVisible} timeout={1000 + index * 200}>
//                           <Box sx={{ textAlign: "center" }}>
//                             <Typography
//                               variant="h3"
//                               sx={{
//                                 fontWeight: 800,
//                                 color: theme.palette.primary.main,
//                                 mb: 0.5,
//                               }}
//                             >
//                               {stat.number}
//                             </Typography>
//                             <Typography
//                               variant="caption"
//                               sx={{
//                                 color: "text.secondary",
//                                 fontWeight: 500,
//                                 textTransform: "uppercase",
//                                 letterSpacing: 0.5,
//                               }}
//                             >
//                               {stat.label}
//                             </Typography>
//                           </Box>
//                         </Grow>
//                       </Grid>
//                     ))}
//                   </Grid>
//                 </Box>
//               </Fade>
//             </Grid>

//             {/* Right Column - Image */}
//             <Grid item xs={12} md={6}>
//               <Fade in={isVisible} timeout={1500}>
//                 <Box
//                   sx={{
//                     position: "relative",
//                     height: { xs: "400px", md: "600px" },
//                   }}
//                 >
//                   <HeroImage
//                     src={s1image}
//                     alt="Compassionate caregiver assisting elderly client"
//                   />

//                   {/* Image Decoration */}
//                   <Box
//                     sx={{
//                       position: "absolute",
//                       top: -20,
//                       right: -20,
//                       width: "100px",
//                       height: "100px",
//                       background: "linear-gradient(135deg, #667eea, #764ba2)",
//                       borderRadius: theme.shape.borderRadius * 2,
//                       zIndex: -1,
//                       animation: "float 3s ease-in-out infinite",
//                     }}
//                   />
//                 </Box>
//               </Fade>
//             </Grid>
//           </Grid>
//         </Container>
//       </HeroSection>
//     </>
//   );
// };

// export default SectionOne;
import React, { useEffect, useState, useRef } from "react";
import {
  Box,
  Fade,
  styled,
  Typography,
  Grow,
  Grid,
  Container,
  Button,
  alpha,
} from "@mui/material";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import s1image from "assets/s1image.jpg";
import Slide from "@mui/material/Slide";
import LoginForm from "components/LoginForm";
import { useLocation, useNavigate } from "react-router-dom";
import CaregiverApplyForm from "pages/Caregiver/CaregiverApplyForm";
import ClientInterestForm from "components/ClientInterestForm";
import CountUp from "react-countup";

// Main container with better spacing
const HeroSection = styled(Box)(({ theme }) => ({
  minHeight: "100vh",
  display: "flex",
  alignItems: "center",
  position: "relative",
  overflow: "hidden",
  backgroundColor: "#f8f9fa",
  paddingTop: theme.spacing(10),
  paddingBottom: theme.spacing(10),
  opacity: 0,
  animation: "pageEntrance 1s ease-out 0.2s forwards",
  "@keyframes pageEntrance": {
    "0%": { opacity: 0, transform: "translateY(20px)" },
    "100%": { opacity: 1, transform: "translateY(0)" },
  },
  [theme.breakpoints.down("md")]: {
    paddingTop: theme.spacing(8),
    paddingBottom: theme.spacing(8),
  },
}));

// Floating animation
const FloatingElement = styled(Box)({
  animation: "float 6s ease-in-out infinite",
  "@keyframes float": {
    "0%, 100%": { transform: "translateY(0px)" },
    "50%": { transform: "translateY(-20px)" },
  },
});

// Image container with reflection effect
const ImageContainer = styled(Box)(({ theme }) => ({
  position: "relative",
  height: "500px",
  borderRadius: "20px",
  overflow: "hidden",
  boxShadow: "0 20px 40px rgba(0,0,0,0.1)",
  transform: "perspective(1000px) rotateY(-10deg)",
  transition: "all 0.5s ease",
  "&:hover": {
    transform: "perspective(1000px) rotateY(0deg)",
    boxShadow: "0 30px 60px rgba(0,0,0,0.2)",
  },
  "&::after": {
    content: '""',
    position: "absolute",
    bottom: 0,
    left: 0,
    right: 0,
    height: "100px",
    background: "linear-gradient(to top, rgba(255,255,255,0.8), transparent)",
    zIndex: 2,
  },
  [theme.breakpoints.down("md")]: {
    height: "400px",
    transform: "none",
    marginBottom: theme.spacing(4),
  },
  [theme.breakpoints.down("sm")]: {
    height: "300px",
  },
}));

const StyledImage = styled("img")({
  width: "100%",
  height: "100%",
  objectFit: "cover",
  transition: "transform 0.8s ease",
  filter: "brightness(0.95) contrast(1.05)",
});

const ContentContainer = styled(Box)(({ theme }) => ({
  paddingLeft: theme.spacing(6),
  position: "relative",
  [theme.breakpoints.down("md")]: {
    paddingLeft: 0,
    paddingTop: theme.spacing(4),
  },
}));

const AnimatedTitle = styled(Typography)(({ theme }) => ({
  fontSize: "3.5rem",
  fontWeight: 800,
  lineHeight: 1.1,
  marginBottom: theme.spacing(3),
  background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
  backgroundSize: "200% 200%",
  WebkitBackgroundClip: "text",
  WebkitTextFillColor: "transparent",
  fontFamily: "'Poppins', sans-serif",
  animation: "textShine 3s ease-in-out infinite alternate",
  "@keyframes textShine": {
    "0%": { backgroundPosition: "0% 50%" },
    "100%": { backgroundPosition: "100% 50%" },
  },
  "& span": {
    color: "#2c3e50",
    WebkitTextFillColor: "#2c3e50",
    position: "relative",
    "&::after": {
      content: '""',
      position: "absolute",
      bottom: "-5px",
      left: 0,
      width: "100%",
      height: "4px",
      background: "linear-gradient(90deg, #667eea, #764ba2)",
      borderRadius: "2px",
      transform: "scaleX(0)",
      transformOrigin: "right",
      animation: "underline 2s ease-in-out infinite",
    },
    "@keyframes underline": {
      "0%, 100%": { transform: "scaleX(0)" },
      "50%": { transform: "scaleX(1)" },
    },
  },
  [theme.breakpoints.down("lg")]: {
    fontSize: "3rem",
  },
  [theme.breakpoints.down("md")]: {
    fontSize: "2.5rem",
  },
  [theme.breakpoints.down("sm")]: {
    fontSize: "2rem",
  },
}));

const StyledButton = styled(Button)(({ theme }) => ({
  background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
  color: "white",
  padding: theme.spacing(1.5, 4),
  borderRadius: "50px",
  fontSize: "1rem",
  fontWeight: 600,
  textTransform: "none",
  transition: "all 0.3s ease",
  boxShadow: "0 10px 30px rgba(102, 126, 234, 0.3)",
  position: "relative",
  overflow: "hidden",
  "&::before": {
    content: '""',
    position: "absolute",
    top: 0,
    left: "-100%",
    width: "100%",
    height: "100%",
    background:
      "linear-gradient(90deg, transparent, rgba(255,255,255,0.2), transparent)",
    transition: "left 0.7s ease",
  },
  "&:hover": {
    transform: "translateY(-3px)",
    boxShadow: "0 15px 40px rgba(102, 126, 234, 0.5)",
    "&::before": {
      left: "100%",
    },
  },
  "& .MuiButton-endIcon": {
    transition: "transform 0.3s ease",
  },
  "&:hover .MuiButton-endIcon": {
    transform: "translateX(5px) rotate(360deg)",
  },
  [theme.breakpoints.down("sm")]: {
    width: "100%",
    marginBottom: theme.spacing(2),
    fontSize: "0.95rem",
    padding: theme.spacing(1.2, 3),
  },
}));

const CenteredForm = styled(Box)(({ theme }) => ({
  position: "fixed",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  zIndex: 9999,
  width: "100%",
  maxWidth: "500px",
  backgroundColor: "white",
  borderRadius: "20px",
  padding: theme.spacing(4),
  boxShadow: "0 30px 60px rgba(0,0,0,0.3)",
  animation: "formAppear 0.5s ease-out",
  "@keyframes formAppear": {
    "0%": { opacity: 0, transform: "translate(-50%, -60%) scale(0.9)" },
    "100%": { opacity: 1, transform: "translate(-50%, -50%) scale(1)" },
  },
  [theme.breakpoints.down("sm")]: {
    width: "90%",
    padding: theme.spacing(3),
  },
}));

const SectionOne = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [growIn, setGrowIn] = useState(false);
  const [showLoginForm, setShowLoginForm] = useState(false);
  const [showApplyForm, setShowApplyForm] = useState(false);
  const [showClientForm, setShowClientForm] = useState(false);
  const [imageLoaded, setImageLoaded] = useState(false);
  const [isImageHovered, setIsImageHovered] = useState(false);
  const [isInView, setIsInView] = useState(false);
  const [scrollY, setScrollY] = useState(0);
  const heroRef = useRef();

  const book = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
    navigate("/clients/new");
  };

  useEffect(() => {
    setShowClientForm(location.pathname === "/clients/new");
    setShowLoginForm(location.pathname === "/login");
    setShowApplyForm(location.pathname === "/caregiver/new");
  }, [location]);

  useEffect(() => {
    const timer = setTimeout(() => {
      setGrowIn(true);
    }, 300);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsInView(true);
        }
      },
      { threshold: 0.1 },
    );

    if (heroRef.current) observer.observe(heroRef.current);
    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    const handleScroll = () => setScrollY(window.scrollY);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <HeroSection id="home" ref={heroRef}>
      {/* Decorative Background Elements */}
      <Box
        sx={{
          position: "absolute",
          top: "10%",
          right: "5%",
          width: "300px",
          height: "300px",
          borderRadius: "50%",
          background:
            "linear-gradient(135deg, rgba(102, 126, 234, 0.1), rgba(118, 75, 162, 0.05))",
          filter: "blur(60px)",
          zIndex: 0,
          animation: "float 8s ease-in-out infinite",
        }}
      />
      <Box
        sx={{
          position: "absolute",
          bottom: "20%",
          left: "5%",
          width: "200px",
          height: "200px",
          borderRadius: "50%",
          background:
            "linear-gradient(135deg, rgba(118, 75, 162, 0.08), rgba(102, 126, 234, 0.03))",
          filter: "blur(40px)",
          zIndex: 0,
          animation: "float 10s ease-in-out infinite reverse",
        }}
      />

      {/* Forms overlay */}
      {(showLoginForm || showApplyForm || showClientForm) && (
        <Fade
          in={showLoginForm || showApplyForm || showClientForm}
          timeout={500}
        >
          <CenteredForm>
            {showLoginForm && <LoginForm />}
            {showApplyForm && <CaregiverApplyForm />}
            {showClientForm && <ClientInterestForm />}
          </CenteredForm>
        </Fade>
      )}

      <Container maxWidth="lg">
        <Grid container spacing={6} alignItems="center">
          {/* Left Column - Image with reflection */}
          <Grid item xs={12} md={6}>
            <Slide in={true} direction="right" timeout={800}>
              <FloatingElement>
                <ImageContainer
                  onMouseEnter={() => setIsImageHovered(true)}
                  onMouseLeave={() => setIsImageHovered(false)}
                >
                  <Fade in={true} timeout={1200}>
                    <StyledImage
                      src={s1image}
                      alt="Compassionate care at home"
                      onLoad={() => setImageLoaded(true)}
                      sx={{
                        opacity: imageLoaded ? 1 : 0,
                        transform: imageLoaded
                          ? `scale(1.05) translateY(${scrollY * 0.1}px)`
                          : "scale(1.1)",
                        transition: "opacity 1s ease, transform 0.3s ease-out",
                      }}
                    />
                  </Fade>
                  {isImageHovered && (
                    <Box
                      sx={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        background:
                          "linear-gradient(to bottom, rgba(102, 126, 234, 0.1), transparent)",
                        zIndex: 1,
                        transition: "opacity 0.5s ease",
                      }}
                    />
                  )}
                </ImageContainer>
              </FloatingElement>
            </Slide>
          </Grid>

          {/* Right Column - Content */}
          <Grid item xs={12} md={6}>
            <ContentContainer>
              <Grow in={growIn} timeout={800}>
                <Box>
                  <AnimatedTitle variant="h1">
                    COMFORT,
                    <br />
                    COMPASSION &<br />
                    CARE - <span>RIGHT</span>
                    <br />
                    <span>AT HOME!</span>
                  </AnimatedTitle>

                  <Typography
                    variant="h6"
                    sx={{
                      mb: 4,
                      color: "text.secondary",
                      fontWeight: 400,
                      lineHeight: 1.8,
                      fontFamily: "'Inter', sans-serif",
                      animation: "fadeInUp 1s ease-out 0.3s both",
                      "@keyframes fadeInUp": {
                        "0%": { opacity: 0, transform: "translateY(20px)" },
                        "100%": { opacity: 1, transform: "translateY(0)" },
                      },
                    }}
                  >
                    Experience exceptional home care with our dedicated team of
                    professionals. We bring comfort and compassion directly to
                    your doorstep.
                  </Typography>

                  {/* Feature Points */}
                  <Box
                    sx={{ mb: 4, animation: "fadeInUp 1s ease-out 0.5s both" }}
                  >
                    {[
                      "24/7 Care",
                      "Background Verified Staffs",
                      "Personalized Plans",
                    ].map((feature, index) => (
                      <Box
                        key={feature}
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          gap: 1,
                          mb: 1.5,
                          animation: `fadeInRight 0.5s ease-out ${
                            0.7 + index * 0.2
                          }s both`,
                          "@keyframes fadeInRight": {
                            "0%": {
                              opacity: 0,
                              transform: "translateX(-20px)",
                            },
                            "100%": {
                              opacity: 1,
                              transform: "translateX(0)",
                            },
                          },
                        }}
                      >
                        <Box
                          sx={{
                            width: 8,
                            height: 8,
                            borderRadius: "50%",
                            background:
                              "linear-gradient(135deg, #667eea, #764ba2)",
                            animation: "pulse 2s ease-in-out infinite",
                            animationDelay: `${index * 0.3}s`,
                            "@keyframes pulse": {
                              "0%, 100%": { transform: "scale(1)" },
                              "50%": { transform: "scale(1.2)" },
                            },
                          }}
                        />
                        <Typography variant="body2" sx={{ fontWeight: 500 }}>
                          {feature}
                        </Typography>
                      </Box>
                    ))}
                  </Box>

                  <Grow in={growIn} timeout={1200}>
                    <Box
                      sx={{ animation: "slideInRight 1s ease-out 0.5s both" }}
                    >
                      <StyledButton
                        variant="contained"
                        endIcon={<ArrowForwardIcon />}
                        onClick={book}
                        size="large"
                      >
                        Book an Appointment
                      </StyledButton>

                      {/* <Box mt={3} display="flex" gap={2} flexWrap="wrap">
                        <Button
                          variant="outlined"
                          sx={{
                            borderRadius: "50px",
                            textTransform: "none",
                            fontWeight: 500,
                            borderColor: "#667eea",
                            color: "#667eea",
                            "&:hover": {
                              borderColor: "#764ba2",
                              backgroundColor: alpha("#667eea", 0.04),
                              transform: "translateY(-2px)",
                            },
                            transition: "all 0.3s ease",
                          }}
                          onClick={() => navigate("/caregiver/new")}
                        >
                          Become a Caregiver
                        </Button>
                        <Button
                          variant="text"
                          sx={{
                            borderRadius: "50px",
                            textTransform: "none",
                            fontWeight: 500,
                            color: "text.secondary",
                            "&:hover": {
                              color: "#667eea",
                              transform: "translateY(-2px)",
                            },
                            transition: "all 0.3s ease",
                          }}
                          onClick={() => navigate("/login")}
                        >
                          Client Login
                        </Button>
                      </Box> */}
                    </Box>
                  </Grow>

                  {/* Stats Counter */}
                  {isInView && (
                    <Box
                      sx={{
                        mt: 6,
                        display: "flex",
                        gap: 4,
                        justifyContent: "space-around",
                        flexWrap: "wrap",
                      }}
                    >
                      {[
                        { number: 100, label: "Happy Families", suffix: "+" },
                        { number: 98, label: "Satisfaction", suffix: "%" },
                        { number: 24, label: "Hour Care", suffix: "/7" },
                      ].map((stat, index) => (
                        <Fade
                          in={isInView}
                          timeout={1000 + index * 200}
                          key={stat.label}
                        >
                          <Box sx={{ textAlign: "center", minWidth: "100px" }}>
                            <Typography
                              variant="h3"
                              sx={{
                                fontWeight: 800,
                                background:
                                  "linear-gradient(135deg, #667eea, #764ba2)",
                                WebkitBackgroundClip: "text",
                                WebkitTextFillColor: "transparent",
                                fontSize: {
                                  xs: "2rem",
                                  sm: "2.5rem",
                                  md: "3rem",
                                },
                              }}
                            >
                              <CountUp
                                end={stat.number}
                                duration={2}
                                suffix={stat.suffix}
                              />
                            </Typography>
                            <Typography
                              variant="body2"
                              sx={{
                                color: "text.secondary",
                                mt: 0.5,
                                fontSize: "0.875rem",
                              }}
                            >
                              {stat.label}
                            </Typography>
                          </Box>
                        </Fade>
                      ))}
                    </Box>
                  )}
                </Box>
              </Grow>
            </ContentContainer>
          </Grid>
        </Grid>
      </Container>
    </HeroSection>
  );
};

export default SectionOne;
